import React, { useState, useEffect } from 'react';
import { getWisdomMoments } from '../../services/videoActivationAPI';

const THEME_COLORS = {
  wisdom:    { bg: '#EAF3DE', text: '#27500A' },
  family:    { bg: '#EAF3DE', text: '#27500A' },
  career:    { bg: '#E6F1FB', text: '#0C447C' },
  love:      { bg: '#FBEAF0', text: '#4B1528' },
  challenge: { bg: '#FAEEDA', text: '#412402' },
  identity:  { bg: '#FAEEDA', text: '#412402' },
  memory:    { bg: '#F1EFE8', text: '#2C2C2A' },
  humor:     { bg: '#F1EFE8', text: '#2C2C2A' },
};

const WisdomMomentsList = ({ videoId, personName, collapsed: initialCollapsed = true }) => {
  const [moments, setMoments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(initialCollapsed);

  useEffect(() => {
    if (!videoId) return;
    getWisdomMoments({ video_id: videoId })
      .then(data => setMoments(data.moments || data))
      .catch(() => setMoments([]))
      .finally(() => setLoading(false));
  }, [videoId]);

  if (loading) {
    return (
      <div style={{
        height: '40px', background: '#FAEEDA',
        borderRadius: '8px', margin: '8px 0',
        opacity: 0.5,
      }} />
    );
  }

  if (!moments.length) return null;

  return (
    <div style={{
      background: '#FFFCF5',
      border: '1px solid #E8DFC0',
      borderRadius: '8px',
      marginTop: '10px',
      overflow: 'hidden',
    }}>
      {/* Header — always visible, click to expand/collapse */}
      <button
        onClick={() => setIsCollapsed(c => !c)}
        style={{
          width: '100%', background: '#FAEEDA',
          border: 'none', padding: '10px 14px',
          display: 'flex', alignItems: 'center', gap: '8px',
          cursor: 'pointer', textAlign: 'left',
        }}
      >
        <svg width="14" height="14" viewBox="0 0 16 16" fill="#854F0B">
          <path d="M8 2l1.5 3 3.5.5-2.5 2.5.6 3.5L8 10l-3.1 1.5.6-3.5L3 5.5l3.5-.5z"/>
        </svg>
        <span style={{ fontSize: '13px', fontWeight: '600', color: '#412402', flex: 1 }}>
          {moments.length} wisdom moment{moments.length !== 1 ? 's' : ''} found in this video
        </span>
        <span style={{ fontSize: '12px', color: '#854F0B' }}>
          {isCollapsed ? '\u25B6' : '\u25BC'}
        </span>
      </button>

      {/* Moments list — only shown when expanded */}
      {!isCollapsed && (
        <div style={{ padding: '0 14px' }}>
          {moments.map((moment, i) => (
            <div
              key={moment.id}
              style={{
                padding: '10px 0',
                borderBottom: i < moments.length - 1
                  ? '0.5px solid #EDE0C4' : 'none',
              }}
            >
              <p style={{
                fontSize: '14px', color: '#444',
                fontStyle: 'italic', lineHeight: '1.6',
                margin: '0 0 6px 0',
              }}>
                &ldquo;{moment.text}&rdquo;
              </p>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{
                  fontSize: '11px', fontWeight: '600',
                  padding: '2px 8px', borderRadius: '20px',
                  background: THEME_COLORS[moment.theme]?.bg || '#F1EFE8',
                  color: THEME_COLORS[moment.theme]?.text || '#2C2C2A',
                  textTransform: 'capitalize',
                }}>
                  {moment.theme}
                </span>
                <span style={{ fontSize: '11px', color: '#aaa' }}>
                  from this video
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WisdomMomentsList;
